<template>
  <v-card dark flat :color="themes.candidate.light.chip">
    <!-- <v-card-title :class="themes.candidate.light.dialogTitle"> -->
    <!--     <div v-if="achievement.id"> -->
    <!--       <div class="headline"> -->
    <!--         {{ achievement.title }} -->
    <!--       </div> -->
    <!--       <div class="subheading" v-if="achievement.achievedAt"> -->
    <!--         {{ new Date(achievement.achievedAt) | date("MMM yyy") }} -->
    <!--       </div> -->
    <!--     </div> -->
    <!--     <div v-else class="headline"> -->
    <!--       New Merit -->
    <!--     </div> -->
    <!-- </v-card-title> -->

    <v-card-text>
      <v-form v-model="valid">
        <v-text-field
          label="Title"
          v-model="modified.title"
          hint="Name of the merit or award that you received."
          :color="themes.candidate.light.input"
          :rules="rules.title"
          :counter="128"
          required
        />
        <date-picker
          label="Achieved"
          v-model="modified.achievedAt"
          append-icon="mdi-calendar"
          :rules="rules.achievedAt"
          :color="themes.candidate.light.input"
          :theme="themes.candidate.light"
          clearable
        />
        <v-textarea
          label="Description"
          v-model="modified.description"
          hint="Please provide a brief description of the nature of the merit / award"
          :color="themes.candidate.light.input"
          :rules="rules.description"
          :counter="512"
          auto-grow
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-menu :close-on-content-click="false" nudge-top="20" left v-if="modified.id">
        <v-btn slot="activator" :color="themes.candidate.light.danger">
          Delete
        </v-btn>
        <v-card toolbar>
          <v-toolbar card :color="themes.candidate.light.dialogTitle">
            Are you sure?
            <v-spacer />
            <v-btn
              @click="deleteAchievement"
              :color="themes.candidate.light.danger"
              :loading="saving"
              dark
            >
              Delete
            </v-btn>
          </v-toolbar>
        </v-card>
      </v-menu>
      <v-btn :color="themes.candidate.light.cancel" :disabled="!changes" @click="cancel" flat>
        Cancel
      </v-btn>
      <v-btn
        :color="themes.candidate.light.primaryActionButton"
        @click="submit"
        :disabled="!changes || !valid || saving"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// Helpers
import _ from 'lodash'

// Vue Component
export default {
  props: { achievement: { type: Object, required: true } },

  data() {
    return {
      saving: false,
      modified: JSON.parse(JSON.stringify(this.achievement)),
      // Validation
      valid: this.achievement.id != null,
      rules: {
        title: [
          v => !!v || 'must be provided',
          v => {
            return !v || (v && v.length < 128) || 'must be less than 128 characters'
          },
        ],
        description: [
          v => {
            return !v || (v && v.length < 512) || 'must be less than 512 characters'
          },
        ],
      },
    }
  },

  computed: {
    changes() {
      if (!this.achievement.id) return true

      return !_.isEqual(this.modified, this.achievement)
    },
  },

  methods: {
    cancel() {
      this.modified = JSON.parse(JSON.stringify(this.achievement))
      this.$emit('refresh')
    },

    deleteAchievement() {
      this.saving = true
      this.$store
        .dispatch('candidate/achievements/destroy', this.achievement.id)
        .then(
          () => this.$store.dispatch('snackbarSuccess', 'Deleted Successfully'),
          () => this.$store.dispatch('snackbarError', 'Failed to Deleted')
        )
        .finally(() => {
          this.saving = false
          this.$emit('refresh')
        })
    },

    submit() {
      this.saving = true
      const action = this.modified.id
        ? 'candidate/achievements/update'
        : 'candidate/achievements/create'
      this.$store
        .dispatch(action, this.modified)
        .then(
          () => this.$store.dispatch('snackbarSuccess', 'Saved Successfully'),
          () => this.$store.dispatch('snackbarError', 'Failed to Save')
        )
        .finally(() => {
          this.saving = false
          this.$emit('refresh')
        })
    },
  },
}
</script>
